/* eslint-disable react/prop-types */
import React, { useState } from "react";
import Box from "@mui/material/Box";
import DropDownTable from "../DropDownTable/DropDownTable";
import PalletTable from "../PalletTable/PalletTable";
import OverviewTable from "../OverviewTable/OverviewTable";

export const TabTablePanel = (props) => {
  const { 
    value, 
    tabid, 
    index, 
    whichTable, 
    rows, 
    isImperial, 
    totalWeight, 
    containerType, 
    storageContainerType, 
    palletid, 
    ...other 
  } = props;

  function whichTableDisplay(whichTable) {
    if (rows) {
      if (whichTable === 0) {
        return <OverviewTable rows={rows} />;
      } else {
        if (storageContainerType === 0) {
          return (
            <DropDownTable 
              isImperial={isImperial} 
              totalWeight={totalWeight} 
              containerType={containerType} 
              palletid={palletid} 
              rows={rows} 
            />
          );
        } else {
          return (
            <PalletTable 
              isImperial={isImperial} 
              totalWeight={totalWeight} 
              palletid={palletid} 
              containerType={containerType} 
              storageContainerType={storageContainerType} 
              rows={rows} 
            />
          );
        }
      }
    }
    return null;
  }

  return (
    <div
      role="tabpanel"
      hidden={tabid !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {tabid === index && (
        <Box sx={{ overflow: "hidden", overflowY: "scroll" }}>
          {whichTableDisplay(whichTable)}
        </Box>
      )}
    </div>
  );
};

export default TabTablePanel;